import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import * as styles from './product-info.module.scss';

export const ProductInfo = ({
  brandName,
  productLabel,
  mainImage
}) => {
  const imageUrl = mainImage?.url?.replace(/<SIZE>/ig, mainImage?.sizes[1]);
  return (
    <div className={styles.productInfo__container}>
      <Image className={styles.productInfo__image} src={imageUrl} alt={productLabel} />
      <h2 className={styles.productInfo__text}>
        {brandName
              && (
                <span className={styles.productInfo__text_main}>
                  {brandName}{' '}
                </span>
              )}
        <span className={styles.productInfo__text_label}>
          {productLabel}
        </span>
      </h2>
    </div>
  );
};

ProductInfo.propTypes = {
  brandName: string.isRequired,
  productLabel: string.isRequired,
  mainImage: shape({
    url: string,
    sizes: arrayOf(string)
  })
};

ProductInfo.defaultProps = {
  mainImage: undefined
};
